const c = typeof Intl < "u" && typeof Intl.Segmenter == "function" ? new Intl.Segmenter(void 0, { granularity: "grapheme" }) : null;
function u(n) {
  var r;
  if (!n) return "";
  const e = (r = n.match(new RegExp("[\\p{L}\\p{N}]\\p{M}*", "u"))) == null ? void 0 : r[0];
  if (e) return e;
  const t = n.trim();
  if (!t) return "";
  if (c) {
    const [o] = c.segment(t);
    return (o == null ? void 0 : o.segment) ?? "";
  }
  return String.fromCodePoint(t.codePointAt(0));
}
function l(n = "", e = "") {
  return [u(n), u(e)].filter(Boolean).join("");
}
function f(n) {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/i.test(n);
}
function m({
  src: n,
  type: e,
  id: t,
  async: r = !0,
  defer: o = !0
}) {
  return new Promise((i, s) => {
    const a = document.createElement("script");
    a.src = n, a.async = r, a.defer = o, a.onload = i, a.onerror = s, t && (a.id = t), e && (a.type = e), document.body.appendChild(a);
  });
}
function p(n) {
  const e = n.split(".")[1];
  if (!e) throw new Error("Invalid JWT format");
  const t = g(e);
  try {
    return JSON.parse(t);
  } catch {
    throw new Error("Failed to parse JWT payload");
  }
}
function g(n) {
  let e = n.replace(/-/g, "+").replace(/_/g, "/");
  for (; e.length % 4; ) e += "=";
  return d(atob(e));
}
function d(n) {
  const e = Uint8Array.from(n, (t) => t.charCodeAt(0));
  return new TextDecoder().decode(e);
}
function h(n, e = "en") {
  let r = (navigator.languages || [navigator.language]).map((o) => {
    const i = o.split("-")[0];
    return n.find(
      (s) => s === o || s.startsWith(i + "-") || s === i
    );
  }).find((o) => o !== void 0);
  if (!r) {
    const o = e.split("-")[0];
    r = n.find(
      (i) => i.startsWith(o + "-") || i === o
    ) || e;
  }
  return r;
}
function y(n) {
  const e = n || typeof navigator < "u" && (navigator == null ? void 0 : navigator.language) || "en", [t, r] = e.split("-"), i = [
    // Special region rules (highest priority)
    [r === "CA", "google"],
    // Any Canada region
    [r === "US", "google"],
    // Any United States region
    [r === "LU", "microsoft"],
    // Any Luxembourg region
    [r === "NO", "feide"],
    // Any Norway region
    [r === "DK", "unilogin"],
    // Any Denmark region
    // Language specific rules
    [t === "en" && !r, "google"],
    // Regionless English
    [t === "en" && !!r, "microsoft"],
    // Any regioned English
    [t === "nn", "feide"],
    // Any Norwegian Nynorsk
    [t === "nb", "feide"],
    // Any Norwegian Bokmal
    [t === "no", "feide"],
    // Any Norwegian macrolanguage
    [t === "da", "unilogin"]
    // Any Danish
  ].find(([s]) => s);
  return i ? i[1] : "google";
}
export {
  h as chooseBestFitLocale,
  y as chooseDefaultSSOProvider,
  l as getInitials,
  f as isValidEmailAddress,
  u as leadingCharacter,
  m as loadScript,
  p as payloadFromJWT
};
